<template>
  <div class="v-reports">

    <h1 class="v-reports__heading">
      {{ $t('reports.heading') }}
    </h1>


    <div class="v-reports__filters">

      <div class="v-reports__group-by">
        <v-list-filter
          @input="loadData"
          legend="Gruppering"
          v-model="groupBy"
          :options="groupByOptions">
        </v-list-filter>
      </div>
      <div>
        <v-date
          v-model="dateRange"
          :range="true"
          @input="loadData"
          @clear="resetDateRange" />
      </div>
    </div>

    <div class="v-reports__content">
      <div class="v-reports__report">
        <v-ellipsis-loader v-if="request.loading"></v-ellipsis-loader>
        <div class="v-reports__header">
          <h2>
            <template v-if="request.loading">
              {{ $t('reports.loading') }}
              <v-ellipsis-loader color="green"></v-ellipsis-loader>
            </template>
            <template v-else>
              {{ $t('reports.range', {from: humanizedRange.from, to: humanizedRange.to })}}
            </template>
          </h2>
          <div>
            <v-button
              @click="downloadXlsx"
              label="Last ned XLSX"
              :secondary="true"></v-button>
          </div>
        </div>
        <table
          id="v-reports__table"
          class="v-reports__table">
          <template v-for="group in reportsData">
            <v-reports-header :group="group" />

            <template v-for="row in group.orders">
              <v-reports-row
                :row="row"
                :group-by="groupBy" />
            </template>

          </template>
        </table>
        <template v-if="!request.loading && !reportsData.length">
          <div class="v-reports__no-items">
            {{ $t('reports.empty') }}
          </div>
        </template>


      </div>

    </div>
  </div>

</template>

<script>

import XLSX from 'xlsx';
import vEllipsisLoader from "../components/vEllipsisLoader";
import vLink from "../components/vLink";
import vDate from "../components/vDateInput";
import vButton from "../components/vButton";

import moment from "moment";

import vReportsRow from "../components/vReportsRow";
import vReportsHeader from "../components/vReportsHeader";
import vListFilter from "../components/vListFilter";
import apiMixin from "../mixins/apiMixin";
import axios from "axios";

import { mapGetters } from 'vuex';

const defaultDateRange = [
  new moment().startOf("week"),
  new moment().endOf("week"),
];

export default {
  name: "vReports",
  mixins: [
    apiMixin.apiMixin,
  ],
  components: {
    vLink,
    vEllipsisLoader,
    vListFilter,
    vReportsRow,
    vReportsHeader,
    vDate,
    vButton
  },
  props: {
    groupByOptions: {
      type: Array, default: function () {
        return [
          { 'label': "Ingen", 'id': 'none', 'endPoint': process.env.VUE_APP_API_URL + "/reports/orders" },
          {
            'label': "Forhandler",
            'id': 'retailers',
            'endPoint': process.env.VUE_APP_API_URL + "/reports/retailers/orders"
          },
          //   { 'label': "Bilmerke", 'id': 'brands', 'endPoint': "/api/reports/cars/orders" },
          {
            'label': "Bilmodell",
            'id': 'models',
            'endPoint': process.env.VUE_APP_API_URL + "/reports/cars/models/orders"
          }
        ];
      }
    }
  },
  data: function () {
    return {
      request: {
        loaded: false,
        loading: false,
      },
      groupBy: this.groupByOptions[0],
      reportsData: [],
      dateRange: defaultDateRange
    };

  },
  mounted () {
    this.loadData();
  },
  computed: {
    ...mapGetters([
      'getHttp'
    ]),

    dataEndPoint () {
      return this.groupBy.endPoint;
    },
    humanizedRange () {
      return {
        "from": moment(this.dateRange[0]).format("dddd, Do MMMM YYYY"),
        "to": moment(this.dateRange[1]).format("dddd, Do MMMM YYYY"),
      };
    },
  },

  methods: {
    loadData () {
      if (this.call) {
        this.call.cancel();
      }
      this.call = axios.CancelToken.source();
      this.request.loading = true;
      this.loaded = false;
      /* axios with cache adapter */
      const http = this.getHttp;
      let conf = this.apiHeaders;
      conf.headers['Cache-Control'] = 'no-cache';
      conf.params = {
        'fromDate': new Date(this.dateRange[0]).toISOString(),
        'toDate': new Date(this.dateRange[1]).toISOString(),
      };
      conf.cancelToken = this.call.token;
      // todo: generalize two following sections:
      // use cache if available
      conf.forceUpdate = false;
      http.get(this.dataEndPoint, conf).then(response => {
        this.reportsData = response.data;
        this.request.loading = false;

      });
      // do the actual request
      conf.forceUpdate = true;
      http.get(this.dataEndPoint, conf).then(response => {
        this.request.loading = false;
        this.reportsData = response.data;
      });
    },
    downloadXlsx () {
      /* convert from array of arrays to workbook */
      //     var worksheet = XLSX.utils.json_to_sheet(this.reportData);
      //     var new_workbook = XLSX.utils.book_new();
      const tbl = document.getElementById('v-reports__table');
      const wb = XLSX.utils.table_to_book(tbl);

      //  XLSX.utils.book_append_sheet(wb, worksheet, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, "sheetjs.xlsx");
    },
    resetDateRange () {
      this.dateRange = defaultDateRange;
    }
  }

};
</script>

<style lang="scss">
.v-reports {

  text-align: center;

  &__filters {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    padding: 2em;
  }

  &__group-by {
    font-size: 0.9em;
  }

  &__table {
    width: 100%;
  }

  &__content {
    background-color: white;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__salesperson {
  }

  &__customer {
  }

  &__pagination {
    display: flex;
    padding-bottom: 1em;
    justify-content: flex-end;
  }

  &__line-cell {
  }


  &__order-id {
    width: 7em;
  }

  &__product {
    display: flex;
    flex: none;
    width: 23em;
  }

  &__product-id {
    color: #333;
    padding-right: 1em;
    flex: none;
    font-family: monospace;
    width: 4em;
  }

  &__report {
    padding: 2em;
    text-align: left;
    background-color: white;
    width: calc(100%);
  }

  &__cell {
    font-size: .75em;
    padding: .25em 0.5em .25em 0;
    border-bottom: 1px solid #F3F3F3;
  }

  &__cell--number {
    text-align: right;
  }

  &__date-range {
    display: flex;
  }

  &__date-label {
    padding: 0 1em;
  }

  &__line-total {
  }

  &__date {
    width: 5em;
    flex: none;
    align-items: center;
    display: flex;
  }

  &__no-items {
    color: white;
  }

  &__heading {
    padding: 1em 0;
    font-weight: 400;
    color: white;
  }

}


</style>
